import { render, staticRenderFns } from "./sky-add-input.vue?vue&type=template&id=72a6c7f4&scoped=true"
import script from "./sky-add-input.vue?vue&type=script&lang=js"
export * from "./sky-add-input.vue?vue&type=script&lang=js"
import style0 from "./sky-add-input.vue?vue&type=style&index=0&id=72a6c7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6c7f4",
  null
  
)

export default component.exports